import { nanoid } from 'nanoid';

export enum Topic {
    PRODUCT_ITEM_DELETED = 'PRODUCT_ITEM_DELETED',
    PRODUCT_ITEM_CREATED = 'PRODUCT_ITEM_CREATED',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Payload<T = any> = T;
export type Listener<T = Payload> = (payload: T) => void;

const subscribers = new Map<Topic, Map<string, Listener>>();

// eslint-disable-next-line no-restricted-syntax
for (const event of Object.values(Topic)) {
    subscribers.set(event, new Map());
}

export function subscribe<T>(event: Topic, listener: Listener<Payload<T>>): string {
    const subscribersForEvent = subscribers.get(event);
    const id = nanoid();
    if (subscribersForEvent) {
        subscribersForEvent.set(id, listener);
    } else {
        subscribers.set(event, new Map([[id, listener]]));
    }

    return id;
}

export function unsubscribe(event: Topic, id: string): void {
    const subscribersForEvent = subscribers.get(event);
    if (subscribersForEvent) {
        subscribersForEvent.delete(id);
    }
}

export function publish<T>(event: Topic, payload?: Payload<T>): void {
    const subscribersForEvent = subscribers.get(event);
    if (subscribersForEvent) {
        subscribersForEvent.forEach((subscriber) => subscriber(payload));
    }
}
